(function () {
  'use strict';

  angular.module('ringbaPortal')
    .filter('trSmartTableCustomFilter', function(_){
      'ngInject';
      // this matcher recursively checks string fields
      // to see if the pattern matches the values
      function customMatcher (value, pattern) {
        if (typeof value === 'string') {
          if (value.match(new RegExp(_.escapeRegExp(pattern), 'i'))) {
            return true;
          } else {
            return false;
          }
        } else if (typeof value === 'object') {
          let selected = false;
          angular.forEach(value, function (nestedValue){
            selected = selected || customMatcher(nestedValue, pattern);
          });
          return selected;
        }
      }

      return function(input, predicate){
        const out = [];
        angular.forEach(input, function (item){
          let selected = false;

          if (!predicate.$) {
            selected = true;
          }
          else if (predicate.$) {
            selected = customMatcher(item, predicate.$);
          }

          if (selected && predicate.customFilters) {
            selected = predicate.customFilters(item);
          }

          if (selected) {
            out.push(item);
          }

        });
        return out;
      };
    });
})();
